import { render } from "./CouponUsage.vue?vue&type=template&id=0cf1286f"
import script from "./CouponUsage.vue?vue&type=script&lang=js"
export * from "./CouponUsage.vue?vue&type=script&lang=js"
script.render = render

export default script